var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAcademy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1538 18.75C21.1538 19.2 21.4359 19.5 21.8589 19.5C22.282 19.5 22.5641 19.2 22.5641 18.75V9C22.5641 8.55 22.282 8.25 21.8589 8.25C21.4359 8.25 21.1538 8.55 21.1538 9V18.75Z",
    fill: "#0350A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9295 2.32539L0.352564 8.32539C0.141026 8.47539 0 8.70039 0 9.00039C0 9.30039 0.141026 9.52539 0.352564 9.67539L10.9295 15.6754C11.0705 15.7504 11.141 15.7504 11.2821 15.7504C11.4231 15.7504 11.4936 15.7504 11.5641 15.6754L22.141 9.67539C22.3526 9.52539 22.4936 9.30039 22.4936 9.00039C22.4936 8.70039 22.3526 8.47539 22.141 8.32539L11.5641 2.32539C11.3526 2.17539 11.141 2.17539 10.9295 2.32539ZM21.3331 9.00039L11.2468 3.27872L1.16052 9.00039L11.2468 14.7221L21.3331 9.00039Z",
    fill: "#0350A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7629 17.8041C12.2736 18.1627 11.7234 18.2502 11.282 18.2502C10.8406 18.2502 10.2904 18.1627 9.80112 17.8041L5.17088 15.2271V16.5002C5.17088 17.1293 5.67478 17.9916 6.88992 18.7636C8.05368 19.5029 9.64921 20.0002 11.282 20.0002C12.9148 20.0002 14.5103 19.5029 15.6741 18.7636C16.8892 17.9916 17.3931 17.1293 17.3931 16.5002V15.2271L12.7629 17.8041ZM12.2692 16.9502C11.9871 17.1752 11.6346 17.2502 11.282 17.2502C10.9294 17.2502 10.5769 17.1752 10.2948 16.9502L4.23071 13.5752V16.5002C4.23071 18.8252 7.68584 21.0002 11.282 21.0002C14.8781 21.0002 18.3333 18.8252 18.3333 16.5002V13.5752L12.2692 16.9502Z",
    fill: "#0350A2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademy);
export default __webpack_public_path__ + "static/media/academy.9e0264bc714b12fc946f7d298487ef89.svg";
export { ForwardRef as ReactComponent };